import { render, staticRenderFns } from "./taxa_de_aprovacao_reprovacao.vue?vue&type=template&id=4c6e1a43&scoped=true&"
import script from "./taxa_de_aprovacao_reprovacao.vue?vue&type=script&lang=js&"
export * from "./taxa_de_aprovacao_reprovacao.vue?vue&type=script&lang=js&"
import style0 from "./taxa_de_aprovacao_reprovacao.vue?vue&type=style&index=0&id=4c6e1a43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6e1a43",
  null
  
)

export default component.exports